var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCkProLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.999,
    height: 26.85,
    viewBox: "0 0 144.999 26.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-k-pro-logo",
    transform: "translate(0.001 -0.409)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7064",
    "data-name": "Rectangle 7064",
    width: 3.851,
    height: 14.966,
    transform: "translate(15.677 6.216)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40844",
    "data-name": "Path 40844",
    d: "M40.3,18.32a4.516,4.516,0,0,0,2.769-4.314c0-3.286-2.345-4.946-6.552-4.946H31.71V24.026h3.851v-6.27l4.032,6.27h4.543Zm-3.662-1.572H35.561V12.232h1.109c1.566,0,2.587.672,2.587,2.211s-1.089,2.3-2.614,2.3",
    transform: "translate(-10.401 -2.837)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40845",
    "data-name": "Path 40845",
    d: "M76.844,20.608h5.188v3.414H72.94V9.05h3.9Z",
    transform: "translate(-23.924 -2.834)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40846",
    "data-name": "Path 40846",
    d: "M88.32,9.05h9.845v3.407H92.177v2.48H97.9v3.145H92.177v2.527h6v3.414H88.32Z",
    transform: "translate(-28.969 -2.834)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40847",
    "data-name": "Path 40847",
    d: "M129.394,13.42l5.316-7.2h-5.457l-4.919,6.888V6.223h-4.771V21.188h4.771V14.293L132.8,25.24a13.816,13.816,0,0,1-7.318,2.016,13.312,13.312,0,0,1-13.575-13.574,13.574,13.574,0,0,1,27.142,0,13.729,13.729,0,0,1-2.782,8.407Z",
    transform: "translate(-36.705 0)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40848",
    "data-name": "Path 40848",
    d: "M7.949,12.2a4.032,4.032,0,0,0-4.032,4.207,4.032,4.032,0,0,0,4.066,4.207,4.261,4.261,0,0,0,3.642-2.09l2.97,1.942a7.681,7.681,0,0,1-6.72,3.689A7.641,7.641,0,0,1,0,16.407,7.641,7.641,0,0,1,7.862,8.658a7.627,7.627,0,0,1,6.72,3.669l-3.044,2.016A4.113,4.113,0,0,0,7.929,12.22",
    transform: "translate(0 -2.705)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40849",
    "data-name": "Path 40849",
    d: "M57.706,12.2a4.032,4.032,0,0,0-4.066,4.207,4.032,4.032,0,0,0,4.066,4.207,4.254,4.254,0,0,0,3.636-2.09l2.977,1.942a7.889,7.889,0,0,1-14.569-4.032,7.916,7.916,0,0,1,14.6-4.106l-3.051,2.016a4.113,4.113,0,0,0-3.609-2.124",
    transform: "translate(-16.318 -2.705)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40850",
    "data-name": "Path 40850",
    d: "M163.18,10.33h3.468c3.125,0,5.275,1.6,5.275,4.341v.04c0,2.984-2.58,4.523-5.544,4.523h-2.144v5.3H163.18Zm3.239,7.93c2.641,0,4.428-1.378,4.428-3.488v-.04c0-2.251-1.747-3.434-4.3-3.434h-2.332V18.26Z",
    transform: "translate(-53.523 -3.254)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40851",
    "data-name": "Path 40851",
    d: "M178.09,10.325h4.274a5.591,5.591,0,0,1,4.032,1.4,3.716,3.716,0,0,1,1.075,2.634v.04c0,2.379-1.767,3.736-4.16,4.032l4.7,6.048h-1.344l-4.523-5.887h-2.957v5.887h-1.055Zm4.153,7.392c2.372,0,4.14-1.2,4.14-3.252v-.04c0-1.9-1.505-3.1-4.079-3.1h-3.158v6.4Z",
    transform: "translate(-58.413 -3.249)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40852",
    "data-name": "Path 40852",
    d: "M192.739,17.392v-.04a7.146,7.146,0,1,1,14.287-.047v.04a7.146,7.146,0,1,1-14.287.04m13.191,0v-.04a6.056,6.056,0,1,0-12.1-.04v.04a6.056,6.056,0,1,0,12.1.04",
    transform: "translate(-63.217 -3.146)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40853",
    "data-name": "Path 40853",
    d: "M211.521,8.045h-.551V7.87h1.3v.175h-.558V9.516h-.188Z",
    transform: "translate(-69.198 -2.447)",
    fill: "#f7921e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40854",
    "data-name": "Path 40854",
    d: "M213.42,7.87h.188l.6.9.6-.9H215V9.523h-.188V8.186l-.6.88H214.2l-.6-.88V9.523h-.181Z",
    transform: "translate(-70.001 -2.447)",
    fill: "#f7921e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkProLogo);
export default __webpack_public_path__ + "static/media/ck_pro_logo.fc46bac70ed94178b2ea8e82b194ba8c.svg";
export { ForwardRef as ReactComponent };